import { useTranslation } from 'react-i18next';

import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableHeader,
  TableRow,
} from '@/components/ui/Table';

export function PermissionsTable() {
  const { t } = useTranslation('translation', {
    keyPrefix: 'pages.Settings.components.Vtex.components.PermissionsTable',
  });

  const permissions = [
    {
      product: t('data.product1'),
      category: t('data.category1'),
      resource: t('data.resource1'),
    },
    {
      product: t('data.product2'),
      category: t('data.category2'),
      resource: t('data.resource2'),
    },
    {
      product: t('data.product3'),
      category: t('data.category3'),
      resource: t('data.resource3'),
    },
    {
      product: t('data.product4'),
      category: t('data.category4'),
      resource: t('data.resource4'),
    },
    {
      product: t('data.product5'),
      category: t('data.category5'),
      resource: t('data.resource5'),
    },
    {
      product: t('data.product6'),
      category: t('data.category6'),
      resource: t('data.resource6'),
    },
    {
      product: t('data.product7'),
      category: t('data.category7'),
      resource: t('data.resource7'),
    },
  ];

  return (
    <div className="space-y-4">
      <div className="space-y-1">
        <h3 className="text-lg font-bold">{t('title')}</h3>

        <p>{t('description')}</p>
      </div>

      <div className="max-w-[768px] overflow-hidden rounded-xl border border-gray-200 bg-gray-50">
        <Table>
          <TableHeader>
            <TableRow>
              <TableHead className="border-d border border-gray-200 font-semibold text-black">
                {t('headers.product')}
              </TableHead>

              <TableHead className="border border-gray-200 font-semibold text-black">
                {t('headers.category')}
              </TableHead>

              <TableHead className="border border-gray-200 font-semibold text-black">
                {t('headers.resource')}
              </TableHead>
            </TableRow>
          </TableHeader>

          <TableBody>
            {permissions.map((permission) => (
              <TableRow key={permission.resource}>
                <TableCell className="border border-gray-200">
                  {permission.product}
                </TableCell>

                <TableCell className="border border-gray-200">
                  {permission.category}
                </TableCell>

                <TableCell className="border border-gray-200">
                  {permission.resource}
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </div>
    </div>
  );
}
